<div class="photo-upload-wrapper relative" [class.highlight]="highlightBorder">
  <span class="photo-upload-label" [title]="label">{{ label }}</span>

  <label
    class="photo-upload-card"
    [class.disabled]="disabled"
    [class.uploaded]="!!value && !imageBroken"
    [title]="label"
  >
    <input
      type="file"
      [accept]="accept"
      [disabled]="disabled"
      (change)="onChange($event)"
    />

    <img
      *ngIf="value && !imageBroken; else placeholderTpl"
      class="photo-upload-img"
      [src]="safeValue"
      alt="Uploaded photo"
      (error)="onImageError()"
    />

    <ng-template #placeholderTpl>
      <img
        class="photo-upload-placeholder"
        [src]="placeholderSrc"
        alt="Image"
        (error)="handlePlaceholderError($event)"
      />
    </ng-template>
  </label>

  <div *ngIf="magnify">
    <button
      *ngIf="!!value && !imageBroken"
      type="button"
      class="photo-upload-view"
      (click)="openModal($event)"
      title="View photo"
    >
      <span class="material-symbols-rounded">expand_content</span>
    </button>
  </div>

  <button
    *ngIf="!!value && !disabled && !imageBroken"
    type="button"
    class="photo-upload-delete"
    (click)="onRemove($event)"
    title="Remove photo"
  >
    <span class="material-symbols-rounded">delete</span>
  </button>
</div>

<!-- Fullscreen preview modal -->
<div
  *ngIf="showModal"
  class="photo-modal-backdrop"
  (click)="onModalBackdropClick($event)"
>
  <div class="photo-modal-shell" (click)="$event.stopPropagation()">
    <div class="photo-modal-header">
      <h3 class="photo-modal-title">Client Photo</h3>
      <button
        type="button"
        class="photo-modal-close"
        (click)="closeModal()"
        title="Close"
      >
        <span class="material-symbols-rounded">close</span>
      </button>
    </div>
    <div class="photo-modal-body">
      <img
        class="photo-modal-img"
        [src]="safeValue"
        [alt]="label"
        (error)="onImageError(); closeModal()"
      />
    </div>
  </div>
</div>
